var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45703 0.0859375C4.74805 0.0859375 4.2793 0.583984 4.2793 1.33398V6.61914L4.33789 7.86133L3.74023 7.11719L2.44531 5.80469C2.22852 5.58789 1.9707 5.41797 1.60156 5.41797C0.974609 5.41797 0.494141 5.86914 0.494141 6.54297C0.494141 6.85352 0.623047 7.14648 0.857422 7.38086L4.5957 11.125C4.79492 11.3301 5.14062 11.459 5.45703 11.459C5.77344 11.459 6.11328 11.3301 6.31836 11.125L10.0566 7.38086C10.2969 7.14648 10.4258 6.85352 10.4258 6.54297C10.4258 5.86914 9.94531 5.41797 9.31836 5.41797C8.94922 5.41797 8.68555 5.58789 8.47461 5.80469L7.16797 7.11719L6.57617 7.86133L6.62891 6.61914V1.33398C6.62891 0.583984 6.16602 0.0859375 5.45703 0.0859375Z",
    fill: "#A92020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.ba5b1622a35e798d59dd3f9499b33b7d.svg";
export { ForwardRef as ReactComponent };